import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  radioContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    outlineStyle: 'none',
  },
  label: {
    fontSize: 16,
    fontWeight: '400',
    color: colors.newUI.therapist.textBlue100,
    marginLeft: 3,
  },

  // Base circle
  outerCircle: {
    height: 36,
    width: 36,
    borderRadius: 18,
    borderWidth: 1,
    borderColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
  },
  innerDot: {
    width: 16,
    height: 16,
    backgroundColor: colors.white,
    borderRadius: 8,
  },

  // UNSELECTED STATES
  defaultOuter: {
    borderColor: colors.newUI.therapist.blue60,
    backgroundColor: colors.newUI.therapist.bgBlue10,
  },
  hoverOuter: {
    borderColor: colors.newUI.therapist.blue60,
    backgroundColor: colors.newUI.therapist.blue20,
  },
  focusedOuter: {
    borderColor: colors.newUI.therapist.blue60,
    backgroundColor: colors.newUI.therapist.blue20,
  },

  // SELECTED STATES
  selectedDefaultOuter: {
    backgroundColor: colors.newUI.therapist.blue60,
  },
  selectedHoverOuter: {
    backgroundColor: colors.newUI.therapist.blue50,
  },
  selectedFocusedOuter: {
    backgroundColor: colors.newUI.therapist.blue50,
  },

  // DISABLED STATES
  disabledOuter: {
    backgroundColor: colors.newUI.therapist.grey20,
    borderColor: colors.newUI.therapist.grey60,
  },
  disabledOuterSelected: {
    backgroundColor: colors.newUI.therapist.grey60,
    borderColor: colors.newUI.therapist.grey60,
  },
  disabledInner: {
    backgroundColor: colors.newUI.therapist.grey20,
  },

  // custom focus outline (for web)
  focusWrapper: {
    padding: 2,
    borderRadius: 7,
    borderWidth: 2,
    borderColor: 'transparent',
  },
  focusOutline: {
    borderColor: colors.newUI.therapist.blue50,
  },
});
